<div class="modal-header">
    <h3>
        <strong>Complete Job</strong>
    </h3>
</div>

<div class="modal-body">
    <div class="row">
        <bryntum-date-time-field
            #startDateTime
            label="Start date & time"
            [value]="startDateTimeConfig.value"
            [dateField]="startDateTimeConfig.dateField!"
            [timeField]="startDateTimeConfig.timeField!"
            (onChange)="onStartDateTimeChange($event)"
        >
        </bryntum-date-time-field>
    </div>

    <div class="row pt-3">
        <bryntum-date-time-field
            #endDateTime
            label="End date & time"
            [value]="endDateTimeConfig.value"
            [dateField]="endDateTimeConfig.dateField!"
            [timeField]="endDateTimeConfig.timeField!"
            (onChange)="onEndDateTimeChange($event)"
        >
        </bryntum-date-time-field>
    </div>

</div>

<div class="modal-footer">
    <button
        type="button"
        class="btn btn-default"
        (click)="activeModal.dismiss(false)"
    >Close</button>
    <button
        #completeButton
        type="button"
        class="btn btn-mogo btn-primary"
        (click)="onComplete()"
        [disabled]="completeButtonDisable"
    >Complete</button>
</div>